import React from "react";
import Contactus from "../sections/ContactUs/ContactUs";
function ContactUs() {
  return (
    <>
      <Contactus />
    </>
  );
}

export default ContactUs;
